import type { CoachMarkSpec } from '@/features/coach-marks';

export const CONTEXT_COLLECTION_OFF_COACH_MARK: CoachMarkSpec = {
  id: 'contextCollectionOff',
  version: 'v1',
  title: 'Context awareness is off',
  description:
    'Turn it on anytime from here. Until then, Littlebird only knows what you tell it.',
  width: 'sm',
};
